export const tertiaryHoverSx = (theme) => ({
  '&:hover': {
    color: theme.palette.tertiary.main,
  },
});

export const buttonSx = (theme) => ({
  color: theme.palette.default.main,
  backgroundColor: theme.palette.tertiary.main,
  '&:hover': {
    backgroundColor: theme.palette.tertiary.main,
    filter: 'brightness(70%)',
  },
});

export const flexCenterSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const marginRight12Sx = { marginRight: '12px' };

export const marginTop16Sx = {
  marginTop: '16px',
};

export const centerTextSx = {
  textAlign: 'center',
};

export const centerText16pxMarginSx = {
  textAlign: 'center',
  margin: '16px 0',
};

export const fontSize14Sx = { fontSize: '14px' };

export const font900Sx = {
  fontWeight: 900,
};

export const font700Sx = {
  fontWeight: 700,
};

export const font500Sx = {
  fontWeight: 500,
};

export const padding12Sx = { padding: '12px' };
export const padding0Sx = { padding: 0 };

export const containerSx = (height) => ({
  height: height,
  display: 'flex',
  alignItems: 'center',
  minHeight: '600px',
});

export const boxContainerSx = {
  width: '100%',
  overflow: 'hidden',
  flexDirection: 'column',
  ...flexCenterSx,
};

export const marginTop24Sx = { marginTop: '24px' };
export const marginBottom16Sx = { marginBottom: '16px' };
export const paddingTop64Sx = { paddingTop: '64px' };

export const formInputSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    color: theme.palette.secondary.main,
    '& fieldset': {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.quaternary.main,
      color: theme.palette.secondary.main,
    },
    '&.Mui-focused fieldset': {
      color: theme.palette.secondary.main,
    },
    '& ::-webkit-calendar-picker-indicator': {
      filter: 'invert(1)',
    },
  },
});

export const inputLabelPropsSx = (theme, isDisableLabel) => ({
  style: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    color: theme.palette.secondary.main,
  },
  shrink: isDisableLabel,
});

export const noDataMessageContainerSx = {
  ...flexCenterSx,
  padding: '24px',
  maxWidth: '500px',
  margin: '0 auto',
};

export const mediaCardSx = (theme) => ({
  maxWidth: '345px',
  minWidth: '345px',
  backgroundColor: theme.palette.background.secondary,
  flex: '0 0 50%',
  margin: '16px',
});

export const mediaCardHeaderSx = (theme) => ({
  color: `${theme.palette.secondary.main} !important`,
});

export const mediaCardTypographySx = {
  style: {
    fontSize: '18px',
    ...font700Sx,
  },
};

export const mediaContainerSx = (isMobile) => ({
  ...flexCenterSx,
  flexDirection: isMobile ? 'column' : 'row',
  marginBottom: '80px',
  flexFlow: 'row wrap',
});

export const tableTabPanelContainerSx = {
  padding: '44px 0px 24px 0px',
};

export const tabPanelContainerSx = {
  padding: '64px 24px calc(env(safe-area-inset-bottom, 0) + 24px) 24px',
};

export const coachContainerSx = {
  padding: '0 24px calc(env(safe-area-inset-bottom, 0) + 24px) 24px',
};

export const appBarSx = (theme) => ({
  backgroundColor: theme.palette.background.default,
  height: '50px',
  boxShadow: 'none',
  position: 'fixed',
  maxWidth: '1100px',
  left: '50%',
  transform: 'translate(-50%)',
});

export const toolbarSx = {
  minHeight: '50px !important',
  paddingLeft: '12px',
};

export const maxWidth345CenteredSx = { margin: '0 auto', maxWidth: '345px' };

export const marginRight8Sx = { marginRight: '8px' };

export const headerActionBtnSx = { color: '#71767b' };
